<dx-popup
  [(visible)]="showModal"
  [showTitle]="false"
  [showCloseButton]="false"
  [width]="'90%'"
  [maxWidth]="440"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [wrapperAttr]="{ 
    class: 'content-unlocked-popup' 
  }"
>
  <div class="content-unlocked">
    <div class="cu-icon-wrap">
      <div class="cu-icon-circle">
        <i class="dx-icon-check cu-icon-check"></i>
      </div>
    </div>

    <h2 class="cu-title">
      {{ 'ONBOARDING.CONTENT-UNLOCKED.TITLE' | translate }}
    </h2>

    <p class="cu-description">
      {{
        'ONBOARDING.CONTENT-UNLOCKED.DESCRIPTION'
          | translate: { trainingsCount: trainingsCount, categoriesCount: categoriesCount }
      }}
    </p>

    <dx-button
      class="cu-continue-btn"
      [text]="'COMMON.CONTINUE' | translate"
      type="normal"
      (onClick)="onContinue()"
    ></dx-button>
  </div>
</dx-popup>